import { useTranslation } from 'react-i18next';
import { usePendingCount } from '../../hooks/usePendingOrders';
import { Badge } from '../ui/Badge';

/** Pending-order count; renders nothing at 0. */
export const NavBadge = ({ className }: { className?: string }) => {
    const { t } = useTranslation();
    const { count } = usePendingCount();
    return count > 0 ? <Badge count={count} label={t('shell.newOrders', { count })} className={className} /> : null;
};
